'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _base = require('./base');

var _base2 = _interopRequireDefault(_base);

var _toggleClass = require('../helpers/dom/toggle-class');

var _toggleClass2 = _interopRequireDefault(_toggleClass);

var _hasClass = require('../helpers/dom/has-class');

var _hasClass2 = _interopRequireDefault(_hasClass);

var _parseAttribute = require('../helpers/dom/parse-attribute');

var _debounce = require('../helpers/util/debounce');

var _debounce2 = _interopRequireDefault(_debounce);

var _hasParent = require('../helpers/traversal/has-parent');

var _hasParent2 = _interopRequireDefault(_hasParent);

var _getParent = require('../helpers/traversal/get-parent');

var _getParent2 = _interopRequireDefault(_getParent);

var _messaging = require('../mixins/messaging');

var _messaging2 = _interopRequireDefault(_messaging);

var _mixin = require('../helpers/util/mixin');

var _mixin2 = _interopRequireDefault(_mixin);

var _makeElement = require('../helpers/dom/make-element');

var _makeElement2 = _interopRequireDefault(_makeElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Auto Suggest
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * An auto suggest container.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @example
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * new AutoSuggest(el, {
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *   // Optional. Callback for when the input value changes.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *   onChange(value, inputInstance) {}
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * });
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @module components/auto-suggest.js
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var noop = function noop() {};

var AutoSuggest = function (_BaseComponent) {
  _inherits(AutoSuggest, _BaseComponent);

  /**
   * AutoSuggest constructor.
   * @param {Element} el
   * @param {Object} params
   */
  function AutoSuggest(el) {
    var _this;

    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, AutoSuggest);

    params.elRequired = true;

    if (!(_this = _possibleConstructorReturn(this, _BaseComponent.call(this, el, params)), _this)) {
      return _possibleConstructorReturn(_this);
    }

    _this._bindEventListenerCallbacks();
    _this._addEventListeners();

    if (_this.inputEl.value) {
      _this.show();
      _this._onInput();
    }
    return _possibleConstructorReturn(_this);
  }

  /**
   * Cache elements.
   * @param {Element} el
   */


  AutoSuggest.prototype._cacheElements = function _cacheElements(el) {

    this.el = el;
    this.inputEl = this.el.querySelector('.spark-auto-suggest__field');
    this.labelEl = this.el.querySelector('.spark-label');
    this.listBoxEl = this.el.querySelector('.spark-auto-suggest__listbox');
    this.clearButtonEl = this.el.querySelector('.spark-auto-suggest__clear-btn');

    if (!this.inputEl) {
      throw new Error('No <input> element present in input container!', this.el);
    }

    this.messageEl = this.el.querySelector('.spark-input__message') || (0, _makeElement2.default)('<span class="spark-input__message"></span>');
  };

  /**
   * Parse parameters from the elements.
   */


  AutoSuggest.prototype._parseParams = function _parseParams() {

    this.clickedWithinAutoSuggest = false;
    this.isActive = this.inputEl.value ? true : false;
    this.autoSuggestTerms = this.autoSuggestTerms !== null && Array.isArray(this.autoSuggestTerms) ? this.autoSuggestTerms : null;
    this.minLength = this.minLength !== null ? this.minLength : (0, _parseAttribute.number)(this.el, 'data-min-length', 2);
    this.maxSuggestions = this.maxSuggestions !== null ? this.maxSuggestions : (0, _parseAttribute.number)(this.el, 'data-max-suggestions', 2);
    this.showAllTerms = this.showAllTerms !== null ? this.showAllTerms : (0, _parseAttribute.boolean)(this.el, 'data-show-all-terms', false);
    this.showNoResultsFound = this.showNoResultsFound !== null ? this.showNoResultsFound : (0, _parseAttribute.boolean)(this.el, 'data-show-no-results-found', false);
    this.noResultsFoundText = this.noResultsFoundText !== null ? this.noResultsFoundText : 'No results found';

    if (this.autoSuggestTerms) {
      this.termsObject = _typeof(this.autoSuggestTerms[0]) === 'object' ? true : false;
    }

    if (this.autoSuggestTerms === null && this.customGetSuggestions === null) {
      throw new Error('No Auto Suggest terms or custom search function provided!', this.el);
    }
  };

  /**
   * Create bound versions of event listener callbacks and store them.
   * Otherwise we can't unbind from these events later because the
   * function signatures won't match.
   */


  AutoSuggest.prototype._bindEventListenerCallbacks = function _bindEventListenerCallbacks() {

    this._onFocusBound = this._onFocus.bind(this);
    this._onBlurBound = (0, _debounce2.default)(this._onBlur.bind(this), 100);
    this._onInputBound = this._onInput.bind(this);
    this._onClearClickBound = this._onClearClick.bind(this);
    this._onWindowClickBound = this._onWindowClick.bind(this);
    this._onKeyupBound = this._onKeyup.bind(this);
    this._onKeydownBound = this._onKeydown.bind(this);
  };

  /**
   * Add event listeners for DOM events.
   */


  AutoSuggest.prototype._addEventListeners = function _addEventListeners() {

    this.inputEl.addEventListener('focus', this._onFocusBound);
    this.inputEl.addEventListener('blur', this._onBlurBound);
    this.inputEl.addEventListener('input', this._onInputBound);

    if (this.clearButtonEl) {
      this.clearButtonEl.addEventListener('click', this._onClearClickBound);
    }

    this._addWindowEventListeners();
  };

  /**
   * Remove event listeners for DOM events..
   */


  AutoSuggest.prototype._removeEventListeners = function _removeEventListeners() {

    this.inputEl.removeEventListener('focus', this._onFocusBound);
    this.inputEl.removeEventListener('blur', this._onBlurBound);
    this.inputEl.removeEventListener('input', this._onInputBound);

    if (this.clearButtonEl) {
      this.clearButtonEl.removeEventListener('click', this._onClearClickBound);
    }

    this._removeWindowEventListeners();
  };

  /**
   * Add event listeners for DOM events.
   */


  AutoSuggest.prototype._addWindowEventListeners = function _addWindowEventListeners() {

    this._removeWindowEventListeners();
    window.addEventListener('click', this._onWindowClickBound);
    window.addEventListener('keyup', this._onKeyupBound);
    window.addEventListener('keydown', this._onKeydownBound);
  };

  /**
   * Remove event listeners for DOM events.
   */


  AutoSuggest.prototype._removeWindowEventListeners = function _removeWindowEventListeners() {

    window.removeEventListener('click', this._onWindowClickBound);
    window.removeEventListener('keyup', this._onKeyupBound);
    window.removeEventListener('keydown', this._onKeydownBound);
  };

  /**
   * When the input element gains focus.
   * @param {Object} e
   */


  AutoSuggest.prototype._onFocus = function _onFocus() {

    this.show();
    (0, _toggleClass2.default)(this.inputEl, 'focus', true);

    // Show all terms on initial focus if configured and there isn't an initial entry
    if (this.showAllTerms && !this.listBoxElOpen && !this.inputEl.value && this.customGetSuggestions === null) {
      this._displayAllSuggestions();
      return;
    }

    // If input has a value, display the list if there are matches
    if (this.inputEl.value && !this.listBoxElOpen) {
      var inputString = this.inputEl.value;

      if (inputString.length > 0) {
        (0, _toggleClass2.default)(this.clearButtonEl, 'visible', true);
      }

      if (inputString.length >= this.minLength) {
        this._updateSuggestionsDisplay();
      }
    }
  };

  /**
   * When the input element loses focus.
   * @param {Object} e
   */


  AutoSuggest.prototype._onBlur = function _onBlur() {

    if (this.clickedWithinAutoSuggest) {
      this.clickedWithinAutoSuggest = false;
      this.inputEl.focus();
      return;
    }

    var activeElement = document.activeElement;

    if (!(0, _hasParent2.default)(activeElement, this.el)) {
      if (!this.inputEl.value) {
        this.hide();
      }

      this._closeListbox();
      (0, _toggleClass2.default)(this.inputEl, 'focus', false);
    }
  };

  /**
   * When the input receives a value or the value is about to change, update the displayed suggestions
   * @param {Object} e
   */


  AutoSuggest.prototype._onInput = function _onInput() {

    this.listBoxEl.innerHTML = '';

    (0, _toggleClass2.default)(this.listBoxEl, 'visible', false);

    var inputString = this.inputEl.value;

    // If a value was set using value="" but focus is not on the input, do not show suggestions
    // However, show the Clear button since a value is indeed present
    if (document.activeElement !== this.inputEl && inputString.length > 0) {
      (0, _toggleClass2.default)(this.clearButtonEl, 'visible', true);
      return;
    }

    this.showingAllTerms = inputString.length === 0 && this.showAllTerms ? true : false;

    if (this.showingAllTerms) {
      this._displayAllSuggestions();
    }

    if (inputString.length > 0) {
      (0, _toggleClass2.default)(this.clearButtonEl, 'visible', true);
    } else {
      (0, _toggleClass2.default)(this.clearButtonEl, 'visible', false);
    }

    if (inputString.length >= this.minLength) {
      this._updateSuggestionsDisplay();
    }

    (this.onChange || noop)(this.inputEl.value, this);
  };

  /**
   * Create the HTML markup of a suggestion term
   * @param {String} text The suggestion value in HTML format
   * @param {Number} index The index of the suggestion value
   */


  AutoSuggest.prototype._createSuggestionMarkup = function _createSuggestionMarkup(term, index) {
    if (this.termsObject) {

      // Add icon if available
      if (this.autoSuggestTerms[index].icon && this.autoSuggestTerms[index].icon !== '') {
        term = this.autoSuggestTerms[index].icon + '<span class="spark-auto-suggest__list-item__value" data-term-index="' + index + '">' + term + '</span>';
      } else {
        term = '<span class="spark-auto-suggest__list-item__value" data-term-index="' + index + '">' + term + '</span>';
      }

      // Add description if available
      if (this.autoSuggestTerms[index].description && this.autoSuggestTerms[index].description !== '') {
        term += '<span class="spark-auto-suggest__list-item__description">' + this.autoSuggestTerms[index].description + '</span>';
      }
    }

    return term;
  };

  /**
   * Create the HTML markup of a list item
   * @param {String} text The suggestion string in HTML format, including icon and description markup if set
   * @param {Number} index The index of the list item
   */


  AutoSuggest.prototype._createSuggestionsListItemMarkup = function _createSuggestionsListItemMarkup(htmlStr, index) {
    var item = document.createElement('li');
    item.setAttribute('role', 'option');
    item.setAttribute('id', 'spark-auto-suggest__list-item--' + index);
    item.setAttribute('class', 'spark-auto-suggest__list-item');
    item.setAttribute('tabindex', '-1');

    if (this.termsObject) {
      item.setAttribute('data-suggestion-object', true);
    }

    item.innerHTML = htmlStr;

    return item;
  };

  /**
   * Display all Auto Suggest terms. Should not be used in conjunction with showNoResultsFound
   */


  AutoSuggest.prototype._displayAllSuggestions = function _displayAllSuggestions() {
    if (this.autoSuggestTerms.length < 1) {
      return;
    }

    this.showingAllTerms = true;

    var suggestionResults = [];

    for (var i = 0; i < this.autoSuggestTerms.length; i++) {
      var suggestion = this.termsObject ? this.autoSuggestTerms[i].value : this.autoSuggestTerms[i];
      suggestion = this._createSuggestionMarkup(suggestion, i);
      suggestionResults.push(suggestion);
    }

    if (suggestionResults.length) {
      for (var _i = 0; _i < suggestionResults.length; _i++) {
        var resultItem = this._createSuggestionsListItemMarkup(suggestionResults[_i], _i);
        this.listBoxEl.appendChild(resultItem);
      }

      this._openListbox();
      this.resultsCount = suggestionResults.length;
    }
  };

  /**
   * Get and display Auto Suggest terms based on user entry
   */


  AutoSuggest.prototype._updateSuggestionsDisplay = function _updateSuggestionsDisplay() {

    var suggestionResults = [];

    // If custom filtering and display functionality is provided, call it and exit
    if (this.customGetSuggestions) {
      this.customGetSuggestions.bind(this)();
      return;
    }

    for (var i = 0; i < this.autoSuggestTerms.length; i++) {
      var term = this.termsObject ? this.autoSuggestTerms[i].value : this.autoSuggestTerms[i];

      if (term.toLowerCase().indexOf(this.inputEl.value.toLowerCase()) !== -1) {
        var regex = new RegExp(this.inputEl.value, 'gi');
        var suggestion = term.replace(regex, function (string) {
          return '<mark>' + string + '</mark>';
        });

        suggestion = this._createSuggestionMarkup(suggestion, i);

        suggestionResults.push(suggestion);
      }

      if (suggestionResults.length === this.maxSuggestions) {
        break;
      }
    }

    if (suggestionResults.length) {

      // Ensure that listbox is empty before appending content. IE adds "null" to empty <ul> elements
      this.listBoxEl.innerHTML = '';

      for (var _i2 = 0; _i2 < suggestionResults.length; _i2++) {
        var resultItem = this._createSuggestionsListItemMarkup(suggestionResults[_i2], _i2);
        this.listBoxEl.appendChild(resultItem);
      }

      this._openListbox();
      this.resultsCount = suggestionResults.length;
    } else {
      this.resultsCount = 0;

      if (this.showNoResultsFound) {
        var noResult = document.createElement('li');
        noResult.setAttribute('role', 'presentation');
        noResult.setAttribute('class', 'spark-auto-suggest__list-item spark-auto-suggest__list-item--no-results');
        noResult.innerHTML = this.noResultsFoundText;
        this.listBoxEl.appendChild(noResult);

        this._openListbox();
      }
    }
  };

  /**
   * When the Clear Button is clicked, clear the entered value and close the listbox if it is open
   * If showAllTerms is true, display all the terms once the field is clear
   * @param {Object} e
   */


  AutoSuggest.prototype._onClearClick = function _onClearClick(e) {

    e.preventDefault();

    this.inputEl.value = '';
    this.oldVal = null;
    this.inputEl.focus();
    this._closeListbox();

    this.clickedWithinAutoSuggest = false;
    (0, _toggleClass2.default)(this.clearButtonEl, 'visible', false);

    // If showAllTerms is true we need to show the full list on click
    if (this.showAllTerms && !this.listBoxElOpen && !this.inputEl.value && this.customGetSuggestions === null) {
      this._displayAllSuggestions();
    }

    // Manually call onChange method with newly empty input
    (this.onChange || noop)(this.inputEl.value, this);
  };

  /**
   * Show the input by adding the active state
   */


  AutoSuggest.prototype._updateClass = function _updateClass() {
    (0, _toggleClass2.default)(this.el, 'active', this.isActive);
  };

  /**
   * When the window is clicked and the area clicked is not part of the Auto Suggest, close the suggestions list
   * If an item in the suggestions list is clicked, set it as the active/selected item
   * @param {Object} e
   */


  AutoSuggest.prototype._onWindowClick = function _onWindowClick(e) {

    // Check if we have clicked outside of the Auto Suggest component and collapse the Suggestions list if so
    if (e.target !== this.el && !(0, _hasParent2.default)(e.target, this.el) && e.target !== this.listBoxEl && !(0, _hasParent2.default)(e.target, this.listBoxEl)) {
      this._closeListbox();
      (0, _toggleClass2.default)(this.inputEl, 'focus', false);
      return;
    }

    // If we clicked the label, input field or clear button, exit
    if (e.target === this.inputEl || e.target === this.labelEl || e.target === this.clearButtonEl) {
      return;
    }

    // If a valid suggestion wasn't clicked, exit
    if (e.target.getAttribute('role') !== 'option' && !(0, _hasParent2.default)(e.target, this.listBoxEl)) {
      this.clickedWithinAutoSuggest = true;
      return;
    }

    // Set the selected suggestion as the input's value
    var targetID = void 0;

    if (e.target.tagName !== 'li') {
      var li = (0, _getParent2.default)(e.target, 'li', this.listBoxEl);
      targetID = li.getAttribute('id');
    } else {
      targetID = e.target.getAttribute('id');
    }

    this._setActiveSuggestion(targetID);

    // Set focus back to input but dismiss listbox
    this.inputEl.focus();

    // Ensure that _closeListbox is triggered after focus above in IE
    setTimeout(function () {
      this._closeListbox();
    }.bind(this), 0);

    // Allow additional behavior on mouse click of a suggestion
    (this.onSelection || noop)(this.inputEl.value, this);
  };

  /**
   * Set the selected item
   */


  AutoSuggest.prototype._setActiveSuggestion = function _setActiveSuggestion(id) {

    var activeSuggestion = document.getElementById(id);

    if (activeSuggestion) {
      if (this.termsObject) {
        var valueEl = activeSuggestion.querySelector('.spark-auto-suggest__list-item__value');
        this.inputEl.value = valueEl.innerText;
        this.selectedTermsObjectIndex = valueEl.getAttribute('data-term-index');
      } else {
        this.inputEl.value = activeSuggestion.innerText;
      }
    }
  };

  /**
   * When a key is pressed on the window and it's an ESC, close the suggestions list
   * @param {Object} e
   */


  AutoSuggest.prototype._onKeyup = function _onKeyup(e) {
    if (e.keyCode === 27 && document.activeElement === this.inputEl) {
      this._closeListbox();
      this.inputEl.value = '';
    }

    if (e.keyCode !== 38 && e.keyCode !== 40) {
      this.oldVal = this.inputEl.value;
    }
  };

  /**
   * When a key is pressed and it is the Enter key, set the current suggestion as the selected one.
   * If it is the tab key, determine where to shift focus and whether to manage the component's display classes
   * If it is the arrow keys, navigate the suggestions list
   * @param {Object} e
   */


  AutoSuggest.prototype._onKeydown = function _onKeydown(e) {

    // Remove focus from component if navigating away from it via Tab key
    if (e.keyCode === 9 && document.activeElement === this.clearButtonEl) {
      this._closeListbox();
      (0, _toggleClass2.default)(this.inputEl, 'focus', false);
    }

    if (this.resultsCount < 1) {
      return;
    }

    // Set focus back to input if printable keys are pressed
    if (e.keyCode !== 13 && e.keyCode !== 38 && e.keyCode !== 40 && document.activeElement !== this.inputEl) {
      this.inputEl.focus();
      return;
    }

    // Enter key
    if (e.keyCode === 13) {
      e.preventDefault();

      if (document.activeElement !== this.inputEl) {
        this.inputEl.focus();

        // Ensure that _closeListbox is triggered after focus above in IE
        setTimeout(function () {
          this._closeListbox();
        }.bind(this), 0);

        // Allow form submission or other behavior on Enter
        // @deprecated Remove onEnterKey in v4.0.0
        (this.onSelection || this.onEnterKey || noop)(this.inputEl.value, this);
      }

      return;
    }

    // Get the current suggestion which will become "previous" suggestion
    var currentSuggestion = this.getAutoSuggestItem(this.activeSuggestionIndex);

    // Up arrow
    if (e.keyCode === 38) {
      e.preventDefault();

      if (document.activeElement === this.inputEl) {
        this.activeSuggestionIndex = this.resultsCount - 1;
      } else if (this.activeSuggestionIndex <= 0) {
        this.activeSuggestionIndex = -1;

        // Reset value back to what was initially typed
        this.inputEl.value = this.oldVal;
        this.inputEl.setAttribute('aria-activedescendant', '');
        this.inputEl.focus();
      } else {
        this.activeSuggestionIndex--;
      }

      // Down arrow
    } else if (e.keyCode === 40) {
      e.preventDefault();

      if (document.activeElement === this.inputEl) {
        this.activeSuggestionIndex = 0;
      } else if (this.activeSuggestionIndex >= this.resultsCount - 1) {

        // Reset value back to what was initially typed
        this.inputEl.value = this.oldVal;
        this.inputEl.setAttribute('aria-activedescendant', '');
        this.inputEl.focus();
      } else {
        this.activeSuggestionIndex++;
      }
    }

    // Exit at this point if not Up/Down arrow keys
    if (e.keyCode !== 38 && e.keyCode !== 40) {
      return;
    }

    // Find the item at the activeSuggestionIndex
    var newSuggestion = void 0;

    if (this.activeSuggestionIndex >= 0) {
      newSuggestion = this.getAutoSuggestItem(this.activeSuggestionIndex);
    }

    if (currentSuggestion) {

      // Remove focus from single action variation if it exists
      var link = currentSuggestion.querySelector('.spark-link');
      if (link) link.blur();

      currentSuggestion.setAttribute('aria-selected', 'false');
      (0, _toggleClass2.default)(currentSuggestion, 'focus', false);
    }

    if (newSuggestion) {

      // If this is the single action variation, we need to ignore it
      if ((0, _hasClass2.default)(newSuggestion, 'spark-auto-suggest__list-item--action')) {
        var _link = newSuggestion.querySelector('.spark-link');
        if (_link) _link.focus();

        // Reset value of input to initially typed item
        this.inputEl.value = this.oldVal;
        this.inputEl.setAttribute('aria-activedescendant', '');

        return;
      }

      this.inputEl.setAttribute('aria-activedescendant', 'spark-auto-suggest__list-item--' + this.activeSuggestionIndex);
      (0, _toggleClass2.default)(newSuggestion, 'focus', true);
      newSuggestion.setAttribute('aria-selected', 'true');
      newSuggestion.focus();

      // Make this new selection the value of the text input but store old value for cycling purposes
      var targetID = 'spark-auto-suggest__list-item--' + this.activeSuggestionIndex;
      this._setActiveSuggestion(targetID);
    }
  };

  /**
   * Display the suggestions list
   */


  AutoSuggest.prototype._openListbox = function _openListbox() {
    (0, _toggleClass2.default)(this.listBoxEl, 'visible', true);
    this.showingAllTerms === true ? (0, _toggleClass2.default)(this.listBoxEl, 'show-all-terms', true) : (0, _toggleClass2.default)(this.listBoxEl, 'show-all-terms', false);
    this.listBoxElOpen = true;
    this.el.setAttribute('aria-expanded', 'true');
  };

  /**
   * Hide the suggestions list
   */


  AutoSuggest.prototype._closeListbox = function _closeListbox() {

    if (!this.listBoxElOpen) {
      return;
    }

    // Manage visibility of suggestions list, and associated ARIA attributes
    (0, _toggleClass2.default)(this.listBoxEl, 'visible', false);
    (0, _toggleClass2.default)(this.listBoxEl, 'show-all-terms', false);
    this.listBoxElOpen = false;
    this.listBoxEl.innerHTML = '';

    this.el.setAttribute('aria-expanded', 'false');
    this.inputEl.setAttribute('aria-activedescendant', '');

    // Reset whether we are showing all terms
    this.showingAllTerms = false;

    // Reset index and results counter
    this.activeSuggestionIndex = -1;
    this.resultsCount = 0;
  };

  /**
  * Get a listbox element
  * @param {Number} index The index of the element to retrieve
  */


  AutoSuggest.prototype.getAutoSuggestItem = function getAutoSuggestItem(index) {
    return document.getElementById('spark-auto-suggest__list-item--' + index);
  };

  /**
   * Show the input by adding the active state
   */


  AutoSuggest.prototype.show = function show() {
    this.isActive = true;
    this._updateClass();
    return this;
  };

  /**
   * Hide the input by removing the active state.
   */


  AutoSuggest.prototype.hide = function hide() {
    this.isActive = false;
    this._updateClass();
    return this;
  };

  /**
   * Set the value of the input
   * @param {Mixed} value
   */


  AutoSuggest.prototype.setValue = function setValue(value) {
    this.inputEl.value = value;

    if (value) {
      this.show();
      (0, _toggleClass2.default)(this.clearButtonEl, 'visible', true);
    } else {
      this.hide();
    }

    return this;
  };

  /**
   * Get the value of the input.
   * @return {String}
   */


  AutoSuggest.prototype.getValue = function getValue() {
    return this.inputEl.value;
  };

  /**
   * Clear the value of the input.
   */


  AutoSuggest.prototype.clearValue = function clearValue() {
    this.inputEl.value = '';
    return this;
  };

  /**
   * Disable the Auto Suggest.
   */


  AutoSuggest.prototype.disable = function disable() {
    this._closeListbox();
    this.inputEl.blur();
    this.inputEl.setAttribute('disabled', true);

    if (this.clearButtonEl) {
      this.clearButtonEl.setAttribute('disabled', true);
    }

    return this;
  };

  /**
   * Enable the Auto Suggest.
   */


  AutoSuggest.prototype.enable = function enable() {
    this.inputEl.removeAttribute('disabled');

    if (this.clearButtonEl) {
      this.clearButtonEl.removeAttribute('disabled');
    }

    return this;
  };

  /**
   * Remove component from DOM.
   * @param {Boolean} leaveElement
   */


  AutoSuggest.prototype.remove = function remove(leaveElement) {
    return _BaseComponent.prototype.remove.call(this, leaveElement);
  };

  /**
   * Update the element in use and the position.
   * @param {Element} el
   */


  AutoSuggest.prototype.update = function update(el) {
    return _BaseComponent.prototype.update.call(this, el);
  };

  return AutoSuggest;
}(_base2.default);

/**
 * Whitelisted parameters which can be set on construction.
 * @type {Array}
 */


AutoSuggest.prototype._whitelistedParams = ['onChange', 'onEnterKey', 'onSelection', 'autoSuggestTerms', 'showAllTerms', 'showNoResultsFound', 'minLength', 'maxSuggestions', 'noResultsFoundText', 'customGetSuggestions'];

/**
 * Default values for internal properties we will be setting.
 * These are set on each construction so we don't leak properties
 * into the prototype chain.
 * @type {Object}
 */
AutoSuggest.prototype.defaults = {
  el: null,
  inputEl: null,
  labelEl: null,
  clearButtonEl: null,
  listBoxEl: null,
  isActive: false,
  clickedWithinAutoSuggest: false,
  oldVal: null,
  showingAllTerms: false,
  resultsCount: 0,
  activeSuggestionIndex: -1,
  termsObject: null,
  selectedTermsObjectIndex: null,
  listBoxElOpen: false,
  minLength: null,
  maxSuggestions: 7,
  autoSuggestTerms: null,
  showNoResultsFound: null,
  showAllTerms: null,
  noResultsFoundText: null,
  customGetSuggestions: null,
  onChange: null,
  onEnterKey: null,
  onSelection: null,
  _onFocusBound: null,
  _onBlurBound: null,
  _onInputBound: null,
  _onClearClickBound: null,
  _onKeyupBound: null,
  _onKeydownBound: null,
  _onWindowClickBound: null
};

(0, _mixin2.default)(AutoSuggest.prototype, _messaging2.default);

exports.default = AutoSuggest;
module.exports = exports['default'];
//# sourceMappingURL=auto-suggest.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@sabre/aven-spark/js/dist/components/auto-suggest.js
// module id = 842
// module chunks = 0